import { css } from 'styled-components';
export const StyleButtonBase = css `
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  border: 0;
  border-radius: 0;
  outline: 0;
`;
